import React from 'react';
import { c as classnames } from '../../index-2586sEvh.js';
import NextLink from 'next/link';
import '../../_commonjsHelpers-jjO7Zipk.js';

const Link = ({ id, children, href, isActive, title, className, target, ariaLabel, img, black = false, noUnderline = false, align = null, noTabbing = false, ariaHidden = false, labeledBy = '', onClick, tabIndex, noClass = false, ...rest }) => {
    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
        }
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            handleClick(event);
        }
    };
    if (href) {
        return (React.createElement(NextLink, { href: href, id: id, "data-testid": id, legacyBehavior: false, style: img ? { backgroundImage: `url(${img})` } : {}, className: classnames(!noClass && 'base-link', {
                active: isActive,
            }, black && 'link-black', align && `align-${align}`, className, noUnderline && 'no-underline'), title: title, target: target || null, "aria-label": ariaLabel || null, rel: "noreferrer", ...(noTabbing ? { tabIndex: -1 } : {}), ...(ariaHidden && { 'aria-hidden': true }), ...(labeledBy && { 'aria-labelledby': labeledBy }), onClick: handleClick, onKeyPress: handleKeyPress, tabIndex: tabIndex || 0, locale: false, ...rest }, children));
    }
    return (React.createElement("button", { type: "button", "data-testid": `${className} - ${typeof children === 'string' ? children : ''}`, className: classnames(!noClass && 'base-link', {
            active: isActive,
        }, black && 'link-black', align && `align-${align}`, className, noUnderline && 'no-underline'), title: title, "aria-label": ariaLabel || null, onClick: handleClick, ...(noTabbing ? { tabIndex: -1 } : {}), ...(ariaHidden && { 'aria-hidden': true }), ...(labeledBy && { 'aria-labelledby': labeledBy }), ...rest }, children));
};

export { Link as default };
//# sourceMappingURL=index.js.map
